import React from 'react';
import './Resume.css';

const Resume = () => {
  return (
    <section id="resume" className="resume">
      <div className="container">
        <h2 className="section-title">Resume</h2>
        <div className="title-underline"></div>
        <p className="section-subtitle">Download or view the full CV</p>

        <div className="resume-content">
          <p className="resume-summary">
            AI, Machine learning and signal processing expert with academic publications, a patent,
            and more than a decade of hands-on experience in neural networks, signal processing,
            and hardware-aware implementations. Former officer and engineer in IDF unit 81 and
            current Machine Learning Engineer in industry.
          </p>

          <div className="resume-actions">
            <a href="/NoamJancoCV2023_2.pdf" target="_blank" rel="noopener noreferrer" className="btn btn-primary">Open Resume (PDF)</a>
            <a href="/NoamJancoCV2023_2.pdf" download className="btn btn-secondary">Download PDF</a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Resume;
